// "use client";

// import { useEffect, useState } from "react";
// import Cookies from "js-cookie";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "./cartContext";
// import { use } from "react";

// export default function ProductCards () {
//     const { updateCartCount } = useCart();

//     const [products, setProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const userId = Cookies.get("userId");
//     const navigate = useNavigate();
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await fetch("https://leapatinternational.com/admin/api/v1/web_product_list.php");

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! Status: ${response.status}`);
//                 }

//                 const result = await response.json();
//                 setProducts(result.data);
//             } catch (error) {
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, []);


//     const handleAddToCart = async (productId, quantity = 1) => {
//         setLoading(true);

//         try {
//             // Make sure this matches your cookie name
//             if (!userId) {
//                 toast.error("Please log in to add items to cart");
//                 navigate("/log-in");
//                 return;
//             }

//             // Prepare form data
//             const formData = new FormData();
//             formData.append("user_id", userId);
//             formData.append("product_id", productId.toString());
//             formData.append("quantity", quantity.toString());

//             // Make API call
//             const response = await fetch("https://leapatinternational.com/admin/api/v1/web_addtocart.php", {
//                 method: "POST",
//                 body: formData,
//             });
//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }
//             const result = await response.json();

//             // Handle successful response
//             if (result.success || result.status === "success") {
//                 await updateCartCount();
//                 toast.success("Product Added  successfully!");
//             } else {
//                 throw new Error(result.message || "Failed to add product to cart");
//             }
//         } catch (error) {
//             console.error("Error adding to cart:", error);
//             toast.error(

//                 "Failed to add product to cart");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="product-cards-wrapper">
//             <div className="container-fluid" style={{ marginTop: "90px" }}>
//                 <div className="row justify-content-center">
//                     <div className="col-12">
//                         <h2 className="text-center mb-5" style={{ fontWeight: "700", color: "#1f2937" }}>
//                             Our Products
//                         </h2>
//                     </div>
//                 </div>

//                 <div className="row justify-content-center g-4 ms-5 me-5">
//                     {products.map((product) => (
//                         <div key={product.id} className="col-12 col-md-6 col-lg-3">
//                             <div
//                                 className="card h-100"
//                                 style={{
//                                     border: "none",
//                                     borderRadius: "20px",
//                                     boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
//                                     transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                                 }}
//                                 onMouseEnter={(e) => {
//                                     e.currentTarget.style.transform = "translateY(-5px)";
//                                     e.currentTarget.style.boxShadow = "0 20px 40px rgba(0, 0, 0, 0.15)";
//                                 }}
//                                 onMouseLeave={(e) => {
//                                     e.currentTarget.style.transform = "translateY(0)";
//                                     e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.1)";
//                                 }}
//                             >
//                                 {/* Product Image */}
//                                 <div className="card-img-top" style={{ padding: "20px 20px 0 20px" }}>
//                                     <img
//                                         src={product.image_gallery[0] || "/placeholder.svg"}
//                                         alt={product.name}
//                                         className="img-fluid"
//                                         style={{
//                                             width: "100%",
//                                             height: "200px",
//                                             objectFit: "cover",
//                                             borderRadius: "15px",
//                                             backgroundColor: "#f8f9fa",
//                                         }}
//                                     />
//                                 </div>

//                                 {/* Card Body */}
//                                 <div className="card-body d-flex flex-column" style={{ padding: "20px" }}>
//                                     {/* Product Name */}
//                                     <h5
//                                         className="card-title mb-2"
//                                         style={{
//                                             fontWeight: "700",
//                                             fontSize: "1.5rem",
//                                             color: "#1f2937",
//                                             lineHeight: "1.2",
//                                         }}
//                                     >
//                                         {product.product_name}
//                                     </h5>

//                                     {/* Product Description */}
//                                     <p
//                                         className="card-text mb-3"
//                                         style={{
//                                             color: "#6b7280",
//                                             fontSize: "1rem",
//                                             lineHeight: "1.5",
//                                             flexGrow: "1",
//                                         }}
//                                     >
//                                         {product.short_description}
//                                     </p>

//                                     {/* Product Price */}
//                                     {/* <div className="mb-3">
//                                         <span
//                                             style={{
//                                                 fontSize: "2rem",
//                                                 fontWeight: "700",
//                                                 color: "#4C4DA4",
//                                                 lineHeight: "1",
//                                             }}
//                                         >
//                                             ${product.price}
//                                         </span>
//                                     </div> */}

//                                     {/* Add to Cart Button */}
//                                     {/* {userId ? (
//                                         <button
//                                             className="btn-signin rounded-3 full-width" onClick={() => handleAddToCart(product.id)}

//                                             onMouseEnter={(e) => {
//                                                 e.currentTarget.style.transform = "translateY(-2px)";
//                                                 e.currentTarget.style.boxShadow = "0 8px 20px rgba(99, 102, 241, 0.4)";
//                                             }}
//                                             onMouseLeave={(e) => {
//                                                 e.currentTarget.style.transform = "translateY(0)";
//                                                 e.currentTarget.style.boxShadow = "none";
//                                             }}
//                                         >
//                                             Add to Cart
//                                         </button>
//                                     ) : null} */}
//                                     <button

//                                         className="btn-signin rounded-3 full-width mt-2" onClick={() => navigate(`/product-details/${product.id}`)}
//                                         onMouseEnter={(e) => {
//                                             e.currentTarget.style.transform = "translateY(-2px)";
//                                             e.currentTarget.style.boxShadow = "0 8px 20px rgba(99, 102, 241, 0.4)";
//                                         }}
//                                         onMouseLeave={(e) => {
//                                             e.currentTarget.style.transform = "translateY(0)";
//                                             e.currentTarget.style.boxShadow = "none";
//                                         }}
//                                     >
//                                         View Details
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Additional Product Cards */}

//             </div>
//         </div>
//     );
// }


"use client";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useCart } from "./cartContext";

export default function ProductCards () {
  const { updateCartCount } = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = Cookies.get("userId");
  const navigate = useNavigate();

const [filters, setFilters] = useState({});
const [selectedFilters, setSelectedFilters] = useState({});
  // Fetch products without filter initially or after applying filters
  const fetchProducts = async (filterParams = {}) => {
    setLoading(true);
    setError(null);
    try {
      let response, data;
      if (Object.keys(filterParams).length === 0) {
        response = await fetch("https://leapatinternational.com/admin/api/v1/web_product_list.php");
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        data = await response.json();
        setProducts(data.data);
      } else {
        const formData = new FormData();
        for (const key in filterParams) {
          if (filterParams[key]) {
            formData.append(key, filterParams[key]);
          }
        }

        response = await fetch("https://leapatinternational.com/admin/api/v1/getProductsByFilter.php", {
          method: "POST",
          body: formData,
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        data = await response.json();
        setProducts(data.data);
      }

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
  const fetchFilters = async () => {
    try {
      const response = await fetch("https://leapatinternational.com/admin/api/v1/getFliterData.php");
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const result = await response.json();

      // Set filters as returned from API (dynamic keys)
      setFilters(result.data);

      // Initialize selectedFilters keys with empty string values
      const initialSelectedFilters = {};
      Object.keys(result.data).forEach(key => {
        initialSelectedFilters[key] = "";
      });
      setSelectedFilters(initialSelectedFilters);

    } catch (err) {
      console.error("Failed to load filter data:", err);
    }
  };

  fetchFilters();
  fetchProducts();

}, []);

  // Handle filter dropdown change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const newSelectedFilters = { ...selectedFilters, [name]: value };
    setSelectedFilters(newSelectedFilters);
    fetchProducts(newSelectedFilters);
  };

  const handleAddToCart = async (productId, quantity = 1) => {
    setLoading(true);
    try {
      if (!userId) {
        toast.error("Please log in to add items to cart");
        navigate("/log-in");
        return;
      }
      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("product_id", productId.toString());
      formData.append("quantity", quantity.toString());
      const response = await fetch("https://leapatinternational.com/admin/api/v1/web_addtocart.php", {
        method: "POST",
        body: formData,
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const result = await response.json();
      if (result.success || result.status === "success") {
        await updateCartCount();
        toast.success("Product Added successfully!");
      } else {
        throw new Error(result.message || "Failed to add product to cart");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error("Failed to add product to cart");
    } finally {
      setLoading(false);
    }
  };

  return (
 <div className="product-cards-wrapper">
  <div className="container-fluid" style={{ marginTop: "100px" }}>
    <div className="justify-content-center" style={{maxWidth:"100%"}}>
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-center mb-5" style={{ fontWeight: "700", color: "#1f2937", marginLeft:"100px" }}>
          Our Products
        </h2>
        
        {/* Enhanced Filter dropdowns */}
        <div className="d-flex justify-content-center gap-3 mb-4 position-relative">
          {Object.entries(filters).map(([filterName, options]) => (
            <div key={filterName} className="custom-select-wrapper">
              <select
                name={filterName}
                value={selectedFilters[filterName]}
                onChange={handleFilterChange}
                className="custom-select"
              >
                <option value="">{`All ${filterName}`}</option>
                {options.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
              <div className="custom-arrow">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1.5L6 6.5L11 1.5" stroke="#494EA1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    {error && <p className="text-danger">Error: {error}</p>}

    <div className="row justify-content-center g-4 ms-5 me-5">
      {products.map((product) => (
        <div key={product.id} className="col-12 col-md-6 col-lg-3">
          <div
            className="card h-100"
            style={{
              border: "none",
              borderRadius: "20px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 20px 40px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.1)";
            }}
          >
            <div className="card-img-top" style={{ padding: "20px 20px 0 20px" }}>
              <img
                src={product.image_gallery[0] || "/placeholder.svg"}
                alt={product.name}
                className="img-fluid"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "15px",
                  backgroundColor: "#f8f9fa",
                }}
              />
            </div>
            <div className="card-body d-flex flex-column" style={{ padding: "20px" }}>
              <h5
                className="card-title mb-2"
                style={{
                  fontWeight: "700",
                  fontSize: "1.5rem",
                  color: "#1f2937",
                  lineHeight: "1.2",
                }}
              >
                {product.product_name}
              </h5>
              <p
                className="card-text mb-3"
                style={{
                  color: "#6b7280",
                  fontSize: "1rem",
                  lineHeight: "1.5",
                  flexGrow: "1",
                }}
              >
                {product.short_description}
              </p>
              <button
                className="btn-signin rounded-3 full-width mt-2"
                onClick={() => navigate(`/product-details/${product.id}`)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 8px 20px rgba(99, 102, 241, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                View Details
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
  
  {/* Add this CSS to your stylesheet */}
  <style>
    {`
    .custom-select-wrapper {
      position: relative;
      display: inline-block;
    }
    
    .custom-select {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 180px;
      padding: 10px 15px;
      font-size: 14px;
      font-weight: 500;
      color: #1f2937;
      background-color: #fff;
      border: 2px solid #494EA1;
      border-radius: 15px;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 10px rgba(73, 78, 161, 0.1);
      outline: none;
      height: 40px;
    }
    
    .custom-select:focus {
      border-color: #3B41E0;
      box-shadow: 0 0 0 3px rgba(59, 65, 224, 0.2);
    }
    
    .custom-select:hover {
      border-color: #3B41E0;
      box-shadow: 0 6px 15px rgba(73, 78, 161, 0.15);
    }
    
    .custom-arrow {
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
      pointer-events: none;
      transition: transform 0.3s ease;
    }
    
    .custom-select:focus + .custom-arrow {
      transform: translateY(-50%) rotate(180deg);
    }
    
    /* Style the dropdown options - this will work in some browsers */
    .custom-select option {
      padding: 12px 15px;
      font-size: 14px;
      color: #1f2937;
      background: white;
    }
    
    .custom-select option:checked {
      background-color: #eef0ff;
      color: #494EA1;
      font-weight: 600;
    }
    
    /* For browsers that support it */
    @supports (-moz-appearance: none) {
      .custom-select option {
        background-color: white;
      }
      
      .custom-select option:hover,
      .custom-select option:focus {
        background-color: #494EA1 !important;
        color: white !important;
      }
    }
    
    @media (max-width: 768px) {
      .custom-select {
        width: 140px;
        font-size: 13px;
        padding: 8px 12px;
      }
    }
    `}
  </style>
</div>
  );
}
